import React, { useState } from 'react'
import { MdArrowBack } from 'react-icons/md'
import { useTranslation } from 'react-i18next'
import Loading from '../Loading'

export default function Token(props) {
    const [errorMessage, setErrorMessage] = useState('')
    const [progress, setProgress] = useState(false)
    const { t, locale } = useTranslation()
    const handleSubmit = async (e) => {
        e.preventDefault()
        setProgress(true)
        const resp = await props.onSubmit(props.email)
        if (resp.status !== 200) {
            setErrorMessage(resp.data)
        } else {
            props.setToken(resp.data)
            props.setAuthSection('enter-new-password')
        }
        setProgress(false)
    }

    return (
        <div className="">
            <div className="modal-title">
                <p className="text-3xl text-textLight text-left font-bold">{t('verifyYourEmail')}</p>
            </div>
            <div className="text-sm text-textLight text-left mt-2">
                <p>{t('weHaveSentYouALinkToGetBackIntoYourAccountAndCheckYourMailAndCopyYourTokenHere')}</p>
            </div>

            <div className="sign-up-section">
                <div className="">
                    <form onSubmit={handleSubmit}>
                        <div className="my-5">
                            <span className="text-textLight text-lg font-semibold text-left flex justify-start">{t('token')}</span>
                            <input
                                className="w-full text-textLight border border-b-deselectPurple py-3 border-x-0 border-t-0"
                                placeholder={t('token')}
                                style={{ backgroundColor: 'transparent' }}
                                value={props.token}
                                // type="email"

                                onChange={(e) => props.setToken(e.target.value)}
                            />
                        </div>
                        <div className="error-message">{errorMessage}</div>
                        <div className="login-form-element-holder px-6 py-3">
                            <button
                                className={`bg-white text-textDark py-3 text-lg font-semibold rounded-full w-full h-[50px] ${
                                    !progress ? 'hover:bg-aquaPulse hover:text-textLight' : ''
                                } duration-[250ms] ease-in-out transition-all flex items-center justify-center`}
                                disabled={progress}
                            >
                                {progress ? <Loading primaryColor="var(--deep-ocean)" /> : t('submit')}
                            </button>
                        </div>
                    </form>
                </div>
                <div>
                    <p className="login-missing-text">
                        <span className="login-missing-text-q">{t('didntGetAMail')}</span>
                        <span className="login-missing-text-action" onClick={() => props.repeatRequest()}>
                            {t('resendARequest')}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    )
}
